import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback, type MouseEvent } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceStatus } from "@components/invoices/InvoiceStatus";
import { useOverlays } from "contexts/OverlayContext";

export const BillableExpenseInvoiceStatusCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, unknown>) => {
        const { openOverlay } = useOverlays();
        const billableExpenseInvoice = row.original.billableExpenseInvoice;
        const status = billableExpenseInvoice?.status;

        const handleClick = useCallback(
            (e: MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                if (!billableExpenseInvoice) {
                    return;
                }
                openOverlay("invoicesDrilldown", {
                    filters: { ids: [billableExpenseInvoice.id] },
                });
            },
            [billableExpenseInvoice, openOverlay],
        );

        if (!status) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <Button
                    variant="ghost"
                    onClick={handleClick}
                    disabled={!billableExpenseInvoice}
                >
                    <InvoiceStatus status={status} showText />
                </Button>
            </ViewTableCell>
        );
    },
);
BillableExpenseInvoiceStatusCell.displayName =
    "BillableExpenseInvoiceStatusCell";
